const userRoleEnums = {
  ADMIN: 'admin',
  HR: 'hr',
  INTERVIEWER: 'interviewer',
  TRAINEE: 'trainee',
  TL: 'tl',
  HOD: 'hod',
  QUALITY: 'quality',
  TRAINER: 'trainer',
  EMPLOYEE: 'employee',
  USER: 'user',
  AGENT: 'agent',
  MANAGER: 'manager',
  PAYROLL_MANAGER: 'payroll_manager',
  TECH_SUPPORT: 'tech_support',
  ASSISTANT_MANAGER: 'assistant_manager',
  SENIOR_HR_MANAGER: 'senior_hr_manager',
  FINANCE: 'finance',
}

const raisedRequest = {
  BACK_DATE_LEAVE: 'back_date_leave',
  ROSTER_CHANGE: 'roster_change',
  SHIFT_CHANGE: 'shift_change',
  BIOMETRIC_ISSUE: 'biometric_issue',
  WORKING_ON_WEEKOFF: 'working_on_weekoff',
  WORKING_ON_LEAVE: 'working_on_leave',
}

const statusEnums = {
  APPROVED: 1,
  REJECTED: 2,
  PENDING: 0,
  ALLOCATED: 3,
  UNALLOCATED: 2,
  REJECTEDAGENT: 4,
  ACTIVEAGENT: 5,
}
const TicketStatusEnums = Object.freeze({
  OPEN: 'open',
  IN_PROGRESS: 'in_progress',
  RESOLVED: 'resolved',
  CLOSED: 'closed',
  RE_OPEN: 're_open',
})

const PriorityEnums = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
}

module.exports = { statusEnums, raisedRequest, userRoleEnums, PriorityEnums, TicketStatusEnums }
